import { ArrowRight, FileSpreadsheet } from "lucide-react";
import { toast } from "sonner";
import type { ChatAttachment } from "../types";

type Props = {
  attachment: ChatAttachment;
};

export function AIChatDownloadAttachment({ attachment }: Props) {
  return (
    <a
      href={attachment.href || "#"}
      target="_blank"
      rel="noreferrer"
      className="mt-3 inline-flex items-center gap-1.5 text-sm font-medium text-primary hover:underline"
      onClick={(e) => {
        if (!attachment.href || attachment.href === "#") {
          e.preventDefault();
          toast.info("Download will be available when the API is connected.");
        }
      }}
    >
      <FileSpreadsheet className="h-4 w-4" />
      {attachment.label}
      <ArrowRight className="h-3.5 w-3.5" />
    </a>
  );
}
